import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card bg-white border-0 p-4 mb-4 rounded-10" }
const _hoisted_2 = {
  class: "tab-content",
  id: "myTabContent"
}
const _hoisted_3 = {
  class: "tab-pane fade show active",
  id: "ethereum1-tab-pane",
  role: "tabpanel",
  "aria-labelledby": "ethereum1-tab",
  tabindex: "0"
}
const _hoisted_4 = { style: {"margin":"-30px -5px 0 -21px"} }
const _hoisted_5 = {
  class: "tab-pane fade",
  id: "ethereum2-tab-pane",
  role: "tabpanel",
  "aria-labelledby": "ethereum2-tab",
  tabindex: "0"
}
const _hoisted_6 = { style: {"margin":"-30px -5px 0 -21px"} }
const _hoisted_7 = {
  class: "tab-pane fade",
  id: "ethereum3-tab-pane",
  role: "tabpanel",
  "aria-labelledby": "ethereum3-tab",
  tabindex: "0"
}
const _hoisted_8 = { style: {"margin":"-30px -5px 0 -21px"} }
const _hoisted_9 = {
  class: "tab-pane fade",
  id: "ethereum4-tab-pane",
  role: "tabpanel",
  "aria-labelledby": "ethereum4-tab",
  tabindex: "0"
}
const _hoisted_10 = { style: {"margin":"-30px -5px 0 -21px"} }
const _hoisted_11 = {
  class: "tab-pane fade",
  id: "ethereum5-tab-pane",
  role: "tabpanel",
  "aria-labelledby": "ethereum5-tab",
  tabindex: "0"
}
const _hoisted_12 = { style: {"margin":"-30px -5px 0 -21px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EthereumRateChart = _resolveComponent("EthereumRateChart")!
  const _component_EthereumRateTwoChart = _resolveComponent("EthereumRateTwoChart")!
  const _component_EthereumRateThreeChart = _resolveComponent("EthereumRateThreeChart")!
  const _component_EthereumRateFourChart = _resolveComponent("EthereumRateFourChart")!
  const _component_EthereumRateFiveChart = _resolveComponent("EthereumRateFiveChart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[5] || (_cache[5] = _createStaticVNode("<div class=\"d-flex flex-wrap gap-2 justify-content-between align-items-center mb-1\"><span class=\"d-block mb-1\">Ethereum Rate</span><div class=\"dropdown action-opt text-center\"><button class=\"btn bg-transparent p-0\" type=\"button\" data-bs-toggle=\"dropdown\" aria-expanded=\"false\"><i data-feather=\"more-vertical\"></i></button><ul class=\"dropdown-menu dropdown-menu-end bg-white border-0 box-shadow\"><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"edit\"></i> Edit </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"eye\"></i> View </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"trash\"></i> Delete </a></li></ul></div></div><div class=\"d-flex align-items-center mb-2\"><h3 class=\"fs-32 fw-bold text-secondary mb-0\">$1,528</h3><span class=\"fw-medium fs-12 text-success bg-success bg-opacity-10 border border-success px-2 rounded-pill ms-2\"> +5.4% <i class=\"ri-arrow-up-line\"></i></span></div><span class=\"fs-12 d-block mb-4\">Vs previous 30 days</span>", 3)),
    _cache[6] || (_cache[6] = _createElementVNode("ul", {
      class: "nav nav-tabs justify-content-between ethereum-rate-tabs",
      id: "myTab",
      role: "tablist"
    }, [
      _createElementVNode("li", {
        class: "nav-item",
        role: "presentation"
      }, [
        _createElementVNode("button", {
          class: "nav-link active",
          id: "ethereum1-tab",
          "data-bs-toggle": "tab",
          "data-bs-target": "#ethereum1-tab-pane",
          type: "button",
          role: "tab",
          "aria-controls": "ethereum1-tab-pane",
          "aria-selected": "true"
        }, " 1D ")
      ]),
      _createElementVNode("li", {
        class: "nav-item",
        role: "presentation"
      }, [
        _createElementVNode("button", {
          class: "nav-link",
          id: "ethereum2-tab",
          "data-bs-toggle": "tab",
          "data-bs-target": "#ethereum2-tab-pane",
          type: "button",
          role: "tab",
          "aria-controls": "ethereum2-tab-pane",
          "aria-selected": "false"
        }, " 5D ")
      ]),
      _createElementVNode("li", {
        class: "nav-item",
        role: "presentation"
      }, [
        _createElementVNode("button", {
          class: "nav-link",
          id: "ethereum3-tab",
          "data-bs-toggle": "tab",
          "data-bs-target": "#ethereum3-tab-pane",
          type: "button",
          role: "tab",
          "aria-controls": "ethereum3-tab-pane",
          "aria-selected": "false"
        }, " 1M ")
      ]),
      _createElementVNode("li", {
        class: "nav-item",
        role: "presentation"
      }, [
        _createElementVNode("button", {
          class: "nav-link",
          id: "ethereum4-tab",
          "data-bs-toggle": "tab",
          "data-bs-target": "#ethereum4-tab-pane",
          type: "button",
          role: "tab",
          "aria-controls": "ethereum4-tab-pane",
          "aria-selected": "false"
        }, " 6M ")
      ]),
      _createElementVNode("li", {
        class: "nav-item",
        role: "presentation"
      }, [
        _createElementVNode("button", {
          class: "nav-link",
          id: "ethereum5-tab",
          "data-bs-toggle": "tab",
          "data-bs-target": "#ethereum5-tab-pane",
          type: "button",
          role: "tab",
          "aria-controls": "ethereum5-tab-pane",
          "aria-selected": "false"
        }, " 1Y ")
      ])
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_EthereumRateChart)
        ]),
        _cache[0] || (_cache[0] = _createStaticVNode("<ul class=\"ps-0 mb-0 list-unstyled mt-30\"><li class=\"d-flex justify-content-between align-items-center mb-4\"><span class=\"fs-12 fw-bold\">11:30 AM</span><span class=\"fs-12 fw-semibold text-secondary\">$3,605.08</span><span class=\"fs-12 fw-medium text-success\">+5.4% </span></li><li class=\"d-flex justify-content-between align-items-center mb-4\"><span class=\"fs-12 fw-bold\">01:20 PM</span><span class=\"fs-12 fw-semibold text-secondary\">$3,615.50</span><span class=\"fs-12 fw-medium text-danger\">-3.21%</span></li><li class=\"d-flex justify-content-between align-items-center\"><span class=\"fs-12 fw-bold\">11:30 AM</span><span class=\"fs-12 fw-semibold text-secondary\">$3,831.13</span><span class=\"fs-12 fw-medium text-success\">+7.32%</span></li></ul>", 1))
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_EthereumRateTwoChart)
        ]),
        _cache[1] || (_cache[1] = _createStaticVNode("<ul class=\"ps-0 mb-0 list-unstyled mt-30\"><li class=\"d-flex justify-content-between align-items-center mb-4\"><span class=\"fs-12 fw-bold\">11:30 AM</span><span class=\"fs-12 fw-semibold text-secondary\">$3,605.08</span><span class=\"fs-12 fw-medium text-success\">+5.4% </span></li><li class=\"d-flex justify-content-between align-items-center mb-4\"><span class=\"fs-12 fw-bold\">01:20 PM</span><span class=\"fs-12 fw-semibold text-secondary\">$3,615.50</span><span class=\"fs-12 fw-medium text-danger\">-3.21%</span></li><li class=\"d-flex justify-content-between align-items-center\"><span class=\"fs-12 fw-bold\">11:30 AM</span><span class=\"fs-12 fw-semibold text-secondary\">$3,831.13</span><span class=\"fs-12 fw-medium text-success\">+7.32%</span></li></ul>", 1))
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_EthereumRateThreeChart)
        ]),
        _cache[2] || (_cache[2] = _createStaticVNode("<ul class=\"ps-0 mb-0 list-unstyled mt-30\"><li class=\"d-flex justify-content-between align-items-center mb-4\"><span class=\"fs-12 fw-bold\">11:30 AM</span><span class=\"fs-12 fw-semibold text-secondary\">$3,605.08</span><span class=\"fs-12 fw-medium text-success\">+5.4% </span></li><li class=\"d-flex justify-content-between align-items-center mb-4\"><span class=\"fs-12 fw-bold\">01:20 PM</span><span class=\"fs-12 fw-semibold text-secondary\">$3,615.50</span><span class=\"fs-12 fw-medium text-danger\">-3.21%</span></li><li class=\"d-flex justify-content-between align-items-center\"><span class=\"fs-12 fw-bold\">11:30 AM</span><span class=\"fs-12 fw-semibold text-secondary\">$3,831.13</span><span class=\"fs-12 fw-medium text-success\">+7.32%</span></li></ul>", 1))
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_EthereumRateFourChart)
        ]),
        _cache[3] || (_cache[3] = _createStaticVNode("<ul class=\"ps-0 mb-0 list-unstyled mt-30\"><li class=\"d-flex justify-content-between align-items-center mb-4\"><span class=\"fs-12 fw-bold\">11:30 AM</span><span class=\"fs-12 fw-semibold text-secondary\">$3,605.08</span><span class=\"fs-12 fw-medium text-success\">+5.4% </span></li><li class=\"d-flex justify-content-between align-items-center mb-4\"><span class=\"fs-12 fw-bold\">01:20 PM</span><span class=\"fs-12 fw-semibold text-secondary\">$3,615.50</span><span class=\"fs-12 fw-medium text-danger\">-3.21%</span></li><li class=\"d-flex justify-content-between align-items-center\"><span class=\"fs-12 fw-bold\">11:30 AM</span><span class=\"fs-12 fw-semibold text-secondary\">$3,831.13</span><span class=\"fs-12 fw-medium text-success\">+7.32%</span></li></ul>", 1))
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createVNode(_component_EthereumRateFiveChart)
        ]),
        _cache[4] || (_cache[4] = _createStaticVNode("<ul class=\"ps-0 mb-0 list-unstyled mt-30\"><li class=\"d-flex justify-content-between align-items-center mb-4\"><span class=\"fs-12 fw-bold\">11:30 AM</span><span class=\"fs-12 fw-semibold text-secondary\">$3,605.08</span><span class=\"fs-12 fw-medium text-success\">+5.4% </span></li><li class=\"d-flex justify-content-between align-items-center mb-4\"><span class=\"fs-12 fw-bold\">01:20 PM</span><span class=\"fs-12 fw-semibold text-secondary\">$3,615.50</span><span class=\"fs-12 fw-medium text-danger\">-3.21%</span></li><li class=\"d-flex justify-content-between align-items-center\"><span class=\"fs-12 fw-bold\">11:30 AM</span><span class=\"fs-12 fw-semibold text-secondary\">$3,831.13</span><span class=\"fs-12 fw-medium text-success\">+7.32%</span></li></ul>", 1))
      ])
    ])
  ]))
}